interface ProgressBarProps {
  current: number
  max: number
  color: string
}

export function ProgressBar({ current, max, color }: ProgressBarProps) {
  const percentage = (current / max) * 100
  
  return (
    <div className="w-full h-12 rounded-full relative overflow-hidden border-2 border-gray-100">
      <div 
        className={`absolute top-0 left-0 h-full ${color}`}
        style={{ width: `${percentage}%` }}
      />
      <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
        <span className="font-medium">{current}/{max}</span>
      </div>
    </div>
  )
}

